import React, { useEffect, useLayoutEffect } from 'react'
import '../../assets/css/components/Inputs/InputNumber.css'
import uniqueId from 'lodash/uniqueId'
import IMask from 'imask'

const PercentInput: React.FC<InputNumberProps> = ({
  label = '',
  placeholder = '',
  register,
  error,
  rules,
  name,
  size = 'default',
  classes,
  containerClasses,
  noArrows,
  disabled,
  innerProps,
  step = 1,
  min = 0,
  addDecimals = false,
}) => {
  const randomId = uniqueId('label-')

  // const element = document.getElementById('input-mask') as HTMLElement

  // let numberMask = IMask(element, {
  //   mask: Number,
  //   thousandsSeparator: ',',
  //   radix: '.'
  // })

  useEffect(() => {
    let element = document.getElementById(randomId) as HTMLElement
    let numberMask = IMask(element, {
      mask: [
        {
          mask: '',
        },
        {
          mask: 'num%',
          lazy: false,
          blocks: {
            num: {
              mask: Number,
              scale: 3,
              min: 0,
              max: 100,
            },
          },
        },
      ],
    })
  }, [])

  return (
    <div className={containerClasses}>
      <label
        htmlFor={randomId}
        className="font-medium text-primary-900 text-xs select-none dark:text-white"
      >
        {label}
      </label>
      <input
        id={randomId}
        // id='input-mask'
        name={name}
        className={`dark:bg-gray-600 dark:border-gray-600 mb-2 dark:text-white ${
          size === 'small'
            ? 'h-inputSmall'
            : size === 'large'
            ? 'h-inputLarge'
            : 'h-inputDefault'
        } ${error && 'border-danger focus:border-danger'} ${
          noArrows ? 'custom-input' : ''
        } ${classes}`}
        type="text"
        placeholder={placeholder}
        ref={register ? register(rules) : undefined}
        {...innerProps}
        disabled={disabled}
        // step={step}
        // min={min}
      />
    </div>
  )
}

export default PercentInput

type InputProps = JSX.IntrinsicElements['input']

interface InputNumberProps {
  label?: string
  placeholder?: string
  size?: 'small' | 'large' | 'default'
  innerProps?: InputProps
  classes?: string
  containerClasses?: string
  noArrows?: boolean
  [key: string]: any
  step?: number
  min?: number
  addDecimals?: boolean
}
